import {ChevronLeft} from '@mui/icons-material';
import {ReactNode} from 'react';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {AppBarProvider} from '../../../components/appBar/appBarContext';
import AssignedLoanCard from '../../../components/card/DrawerCards/AssignedLoanCard';
import SwipeablePanel from '../../../components/drawer/drawer';
import {useAuth} from '../../../config/AuthProvider/authProvider';
import {RootState} from '../../../redux/store';

export default function DrawerBody({
    children,
    isAssigned,
}: {
    children: ReactNode;
    isAssigned?: boolean;
}) {
    return (
        <div className="px-[20px]">
            {isAssigned ? <AssignedLoanCard /> : <CardInfo />}

            <AppBarProvider>
                <SwipeablePanel isAssigned={isAssigned!}>
                    {children}
                </SwipeablePanel>
            </AppBarProvider>
        </div>
    );
}
export const CardInfo = () => {
    const {referenceKey} = useAuth();
    const loanCalculationResult = useSelector(
        (state: RootState) => state.loanCalculationResult
    );
    const navigate = useNavigate();
    return (
        <div
            className="my-2 overflow-hidden h-[calc(33svh-115px)] short:h-[unset] p-4"
            style={{
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '28px',
                background: 'rgba(1, 88, 204, 0.9)',
                backdropFilter: 'blur(12px)',
                WebkitBackdropFilter: 'blur(12px)',
                boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.16)',
            }}
        >
            <div className="w-full h-full flex flex-col justify-between">
                <div className="flex items-center justify-end text-[#FFFFFF] cursor-pointer">
                    {referenceKey && (
                        <>
                            <span
                                className="text-[.785rem]"
                                onClick={() => {
                                    navigate('/loans/detail');
                                }}
                            >
                                مشاهده جزییات
                            </span>
                            <ChevronLeft />
                        </>
                    )}
                </div>
                <div
                    className="flex flex-col items-center text-[#FFFFFF]"
                    style={{fontSize: '18px'}}
                >
                    <div className="font-bold" style={{fontSize: '1.2rem'}}>
                        {loanCalculationResult?.loanAmount?.toLocaleString(
                            'fa'
                        )}
                        <span className="font-normal"> ریال</span>
                    </div>
                    <div style={{fontSize: '1rem'}}>
                        {loanCalculationResult?.financialSupplierTitle}
                    </div>
                </div>
                <div className="flex items-center justify-between">
                    <div className="text-[#FFFFFF] text-[.785rem]">
                        مبلغ هر قسط (ريال):
                    </div>
                    <div
                        className=" !mt-2 "
                        style={{
                            fontSize: '.785rem',
                            letterSpacing: '1.5px',
                            color: '#FFFFFF',
                        }}
                    >
                        {loanCalculationResult?.installmentAmount.toLocaleString(
                            'fa'
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
